// extracted by mini-css-extract-plugin
export default {"wrapper":"NB-z","viewport":"OB-z","container":"PB-z","slide":"QB-z"};